module.exports = __webpack_public_path__ + "img/Assurance-Extra-Life-and-Life-and-Income.172dfaf1.jpg";